import { SelectElement, useFormContext } from "react-hook-form-mui";
import { useTranslation } from "react-i18next";

import { Shared_FormTemplate_QuestionFragment } from "~/shared/components/FormTemplate/fragments/fragments.generated";
import { splitGqlUnion } from "~/shared/helpers/splitGqlUnion";

import { questionConditionOptions } from "../../config/questionConditionOptions";
import QuestionConditionIsEqualFields from "./QuestionConditionIsEqualFields";
import QuestionConditionOrFields from "./QuestionConditionOrFields";

type Props = {
    selectableConditionQuestions: Shared_FormTemplate_QuestionFragment[];
};

export default function QuestionConditionFields({ selectableConditionQuestions }: Props) {
    const { t } = useTranslation("formTemplateEditor");

    const { watch, setValue } = useFormContext();

    const selectedCondition = watch("condition");

    return (
        <>
            <SelectElement
                name="condition.__typename"
                label={t("formTemplateQuestionForm.labelCondition")}
                options={questionConditionOptions.map(condition => ({
                    id: condition.id,
                    label: t(condition.translationKey),
                }))}
                required
                variant="filled"
                onChange={value => {
                    if (value === "GqlSettingsFormTemplateQuestionConditionOr") {
                        setValue("conditionOrConditions", [
                            {
                                id: crypto.randomUUID(),
                                conditionSelectedQuestion: "",
                                conditionSelectedQuestionOption: "",
                            },
                        ]);
                    }
                }}
            />
            {selectedCondition?.__typename &&
                splitGqlUnion(selectedCondition, {
                    GqlSettingsFormTemplateQuestionConditionNone: () => null,
                    GqlSettingsFormTemplateQuestionConditionIsEqual: () => (
                        <QuestionConditionIsEqualFields selectableConditionQuestions={selectableConditionQuestions} />
                    ),
                    GqlSettingsFormTemplateQuestionConditionOr: () => (
                        <QuestionConditionOrFields selectableConditionQuestions={selectableConditionQuestions} />
                    ),
                })}
        </>
    );
}
